<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-monitor-edit
        </v-icon> Assign Product Category
      </h2>
      <v-form
        ref="form"
        v-model="isFormValid"
      >
        <v-container class="my-container-style">
          <v-col
            cols="12"
          >
            <v-autocomplete
              v-model="productCategory"
              menu-props="auto"
              :items="productCategoryList"
              item-value="id"
              item-text="name"
              :rules="[(v) => !!v || 'This field is required']"
              label="Product Category*"
            />
          </v-col>

          <p class="text-sm-left">
            *Indicates required field
          </p>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="assignProductCategory()"
            >
              Assign
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  export default {
    name: 'AssignProductCategory',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      digiboardtimeslotproductcategory: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        showModal: true,
        loading: false,
        isFormValid: false,
        productCategory: '',
      };
    },
    computed: {
      productCategoryList () {
        return this.$store.getters['payments/getProductCategoryList'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      this.fillData();
      await this.getProductCategoryList();
    },
    methods: {
      fillData () {
        this.productCategory = this.digiboardtimeslotproductcategory.id;
      },
      async getProductCategoryList () {
        this.loading = true;
        await this.$store.dispatch('payments/fetchProductCategoryList');
        this.loading = false;
      },
      async assignProductCategory () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        const digiBoardTimeSlotId = this.$route.params.digiBoardTimeSlotId;
        this.loading = true;
        await this.$store.dispatch('digiboards/assignProductCategory', {
          productCategoryId: {
            product_id: this.productCategory,
          },
          digiBoardTimeSlotId: digiBoardTimeSlotId,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Product category assigned successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.$emit('success');
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        }); ;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 21px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
  margin-right: 5px;
}
.my-container-style {
    padding-top: 24px;
}
</style>
